export function ShowRowNearbyBadge() {
  return (
    <span className="text-md rounded-md py-1 px-2 font-medium text-[#0F0F0F] bg-gold">
      Nearby!
    </span>
  );
}
